import { memo, createElement, Fragment } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useVisibilityObservable } from '../InfiniteScroll/context.js';
import { DummyCard, ProductCard } from '../ProductCard/index.js';
import styles from 'ui-components/ProductList.scss';

var _excluded = ["product", "breadcrumbLinks", "idx", "loading", "category", "ProductCardComponent", "pointsPriceId"],
  _excluded2 = ["products", "children", "breadcrumbLinks", "heading", "productsPerRow", "loading", "ProductCardComponent", "category", "pointsPriceId"];
var ListItemBase = function ListItemBase(_ref) {
  var product = _ref.product,
    breadcrumbLinks = _ref.breadcrumbLinks,
    idx = _ref.idx,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    category = _ref.category,
    ProductCardComponent = _ref.ProductCardComponent,
    pointsPriceId = _ref.pointsPriceId,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var el = useVisibilityObservable();
  return /*#__PURE__*/createElement("div", {
    ref: el,
    className: styles.item,
    "data-idx": idx
  }, /*#__PURE__*/createElement("div", {
    className: styles.itemInner
  }, loading ? /*#__PURE__*/createElement(DummyCard, null) : ProductCardComponent ? /*#__PURE__*/createElement(ProductCardComponent, _extends({}, rest, {
    product: product,
    position: idx
  })) : /*#__PURE__*/createElement(ProductCard, {
    className: styles.itemInner,
    product: product,
    breadcrumbLinks: breadcrumbLinks,
    list: category,
    position: idx,
    pointsPriceId: pointsPriceId
  })));
};
var ListItem = /*#__PURE__*/memo(ListItemBase);
var ListItemDummyBase = function ListItemDummyBase(_ref2) {
  var idx = _ref2.idx;
  var el = useVisibilityObservable();
  return /*#__PURE__*/createElement("div", {
    ref: el,
    className: styles.item,
    "data-idx": idx
  }, /*#__PURE__*/createElement("div", {
    className: styles.itemInner
  }, /*#__PURE__*/createElement(DummyCard, null)));
};
var ListItemDummy = /*#__PURE__*/memo(ListItemDummyBase);
var ProductList = function ProductList(_ref3) {
  var products = _ref3.products,
    children = _ref3.children,
    breadcrumbLinks = _ref3.breadcrumbLinks,
    heading = _ref3.heading,
    _ref3$productsPerRow = _ref3.productsPerRow,
    productsPerRow = _ref3$productsPerRow === void 0 ? 4 : _ref3$productsPerRow,
    _ref3$loading = _ref3.loading,
    loading = _ref3$loading === void 0 ? false : _ref3$loading,
    ProductCardComponent = _ref3.ProductCardComponent,
    category = _ref3.category,
    pointsPriceId = _ref3.pointsPriceId,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded2);
  return /*#__PURE__*/createElement(Fragment, null, heading && /*#__PURE__*/createElement("h2", {
    className: styles.heading
  }, heading), /*#__PURE__*/createElement("div", {
    className: cn(styles.block, [styles["block__perRow" + productsPerRow]])
  }, products ? products.map(function (x, i) {
    return x ? /*#__PURE__*/createElement(ListItem, _extends({}, rest, {
      key: x.sku,
      loading: loading,
      breadcrumbLinks: breadcrumbLinks,
      product: x,
      idx: i,
      category: category,
      ProductCardComponent: ProductCardComponent,
      pointsPriceId: pointsPriceId
    })) : /*#__PURE__*/createElement(ListItemDummy, {
      key: i,
      idx: i,
      className: styles.itemInner
    });
  }) : children));
};

export { ListItem, ListItemDummy, ListItemDummyBase, ProductList };
//# sourceMappingURL=index.js.map
